import React, { useState } from 'react';
import { Layout } from 'antd';
import AdminSidebar from '../components/Layout/AdminSidebar';
import TopHeader from '../components/Layout/TopHeader';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => setCollapsed(!collapsed);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Sidebar */}
      <AdminSidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <Layout>
        {/* Top header same as inventory layout */}
        <TopHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        {/* Main content area */}
        <Content
          style={{
            margin: 16,
            padding: 16,
            background: '#fff',
            minHeight: 'calc(100vh - 100px)',
            borderRadius: 8,
            overflow: 'auto'
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
